import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft, CreditCard } from 'lucide-react';

const PaymentCancelled = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="mb-6">
          <XCircle className="w-16 h-16 text-orange-500 mx-auto" />
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          Pagamento Annullato
        </h1>
        
        <p className="text-gray-600 mb-6">
          Hai annullato il pagamento. Nessun addebito è stato effettuato sulla tua carta.
        </p>

        <div className="space-y-3">
          <button
            onClick={() => navigate('/pagamento')}
            className="w-full bg-purple-600 text-white py-2 px-4 rounded-lg font-medium hover:bg-purple-700 transition-colors flex items-center justify-center"
          >
            <CreditCard className="w-4 h-4 mr-2" />
            Riprova Pagamento
          </button>
          
          <button
            onClick={() => navigate('/')}
            className="w-full bg-gray-100 text-gray-700 py-2 px-4 rounded-lg font-medium hover:bg-gray-200 transition-colors flex items-center justify-center"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Torna alla Homepage
          </button>
        </div>
        
        <div className="mt-6 pt-6 border-t border-gray-200">
          <p className="text-sm text-gray-500">
            Hai bisogno di aiuto? 
            <button 
              onClick={() => navigate('/contatti')}
              className="text-purple-600 hover:text-purple-700 ml-1 font-medium"
            >
              Contattaci
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelled;